// extracted by mini-css-extract-plugin
export default {"image":"logo-module--image--7df4e"};